import { render, staticRenderFns } from "./direct_register.vue?vue&type=template&id=22a2d1e8&scoped=true&"
import script from "./direct_register.vue?vue&type=script&lang=js&"
export * from "./direct_register.vue?vue&type=script&lang=js&"
import style0 from "./direct_register.vue?vue&type=style&index=0&id=22a2d1e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22a2d1e8",
  null
  
)

export default component.exports